/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BookmarkResponse,
  HTTPValidationError,
  ListBookmarkedVouchersParams,
  PaginatedResponseVoucherResponse
} from '../model';

import { apiInstance } from '../../lib/apiInstance';




/**
 * Toggle bookmark status for a voucher.
 * @summary Toggle Bookmark
 */
export const toggleBookmark = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<BookmarkResponse>(
      {url: `/api/bookmarks/vouchers/${voucherId}`, method: 'POST', signal
    },
      );
    }



export const getToggleBookmarkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{voucherId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{voucherId: string}, TContext> => {

const mutationKey = ['toggleBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof toggleBookmark>>, {voucherId: string}> = (props) => {
          const {voucherId} = props ?? {};

          return  toggleBookmark(voucherId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ToggleBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof toggleBookmark>>>

    export type ToggleBookmarkMutationError = HTTPValidationError

    /**
 * @summary Toggle Bookmark
 */
export const useToggleBookmark = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof toggleBookmark>>, TError,{voucherId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof toggleBookmark>>,
        TError,
        {voucherId: string},
        TContext
      > => {
      return useMutation(getToggleBookmarkMutationOptions(options), queryClient);
    }
    /**
 * Remove a bookmark for a voucher.
 * @summary Remove Bookmark
 */
export const removeBookmark = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<void>(
      {url: `/api/bookmarks/vouchers/${voucherId}`, method: 'DELETE', signal
    },
      );
    }



export const getRemoveBookmarkMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBookmark>>, TError,{voucherId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof removeBookmark>>, TError,{voucherId: string}, TContext> => {

const mutationKey = ['removeBookmark'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeBookmark>>, {voucherId: string}> = (props) => {
          const {voucherId} = props ?? {};

          return  removeBookmark(voucherId,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveBookmarkMutationResult = NonNullable<Awaited<ReturnType<typeof removeBookmark>>>

    export type RemoveBookmarkMutationError = HTTPValidationError

    /**
 * @summary Remove Bookmark
 */
export const useRemoveBookmark = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeBookmark>>, TError,{voucherId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeBookmark>>,
        TError,
        {voucherId: string},
        TContext
      > => {
      return useMutation(getRemoveBookmarkMutationOptions(options), queryClient);
    }
    /**
 * List bookmarked vouchers for the current user.
 * @summary List Bookmarked Vouchers
 */
export const listBookmarkedVouchers = (
    params?: ListBookmarkedVouchersParams,
 signal?: AbortSignal
) => {


      return apiInstance<PaginatedResponseVoucherResponse>(
      {url: `/api/bookmarks/vouchers`, method: 'GET',
        params, signal
    },
      );
    }




export const getListBookmarkedVouchersQueryKey = (params?: ListBookmarkedVouchersParams,) => {
    return [
    `/api/bookmarks/vouchers`, ...(params ? [params] : [])
    ] as const;
    }


export const getListBookmarkedVouchersQueryOptions = <TData = Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError = HTTPValidationError>(params?: ListBookmarkedVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListBookmarkedVouchersQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listBookmarkedVouchers>>> = ({ signal }) => listBookmarkedVouchers(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListBookmarkedVouchersQueryResult = NonNullable<Awaited<ReturnType<typeof listBookmarkedVouchers>>>
export type ListBookmarkedVouchersQueryError = HTTPValidationError


export function useListBookmarkedVouchers<TData = Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError = HTTPValidationError>(
 params: undefined |  ListBookmarkedVouchersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBookmarkedVouchers>>,
          TError,
          Awaited<ReturnType<typeof listBookmarkedVouchers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBookmarkedVouchers<TData = Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError = HTTPValidationError>(
 params?: ListBookmarkedVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listBookmarkedVouchers>>,
          TError,
          Awaited<ReturnType<typeof listBookmarkedVouchers>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListBookmarkedVouchers<TData = Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError = HTTPValidationError>(
 params?: ListBookmarkedVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Bookmarked Vouchers
 */

export function useListBookmarkedVouchers<TData = Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError = HTTPValidationError>(
 params?: ListBookmarkedVouchersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listBookmarkedVouchers>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListBookmarkedVouchersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get bookmark status for a voucher.
 * @summary Get Bookmark Status
 */
export const getBookmarkStatus = (
    voucherId: string,
 signal?: AbortSignal
) => {


      return apiInstance<BookmarkResponse>(
      {url: `/api/bookmarks/vouchers/${voucherId}/status`, method: 'GET', signal
    },
      );
    }




export const getGetBookmarkStatusQueryKey = (voucherId: string,) => {
    return [
    `/api/bookmarks/vouchers/${voucherId}/status`
    ] as const;
    }


export const getGetBookmarkStatusQueryOptions = <TData = Awaited<ReturnType<typeof getBookmarkStatus>>, TError = HTTPValidationError>(voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBookmarkStatusQueryKey(voucherId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookmarkStatus>>> = ({ signal }) => getBookmarkStatus(voucherId, signal);





   return  { queryKey, queryFn, enabled: !!(voucherId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBookmarkStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getBookmarkStatus>>>
export type GetBookmarkStatusQueryError = HTTPValidationError


export function useGetBookmarkStatus<TData = Awaited<ReturnType<typeof getBookmarkStatus>>, TError = HTTPValidationError>(
 voucherId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookmarkStatus>>,
          TError,
          Awaited<ReturnType<typeof getBookmarkStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookmarkStatus<TData = Awaited<ReturnType<typeof getBookmarkStatus>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookmarkStatus>>,
          TError,
          Awaited<ReturnType<typeof getBookmarkStatus>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBookmarkStatus<TData = Awaited<ReturnType<typeof getBookmarkStatus>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Bookmark Status
 */

export function useGetBookmarkStatus<TData = Awaited<ReturnType<typeof getBookmarkStatus>>, TError = HTTPValidationError>(
 voucherId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBookmarkStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBookmarkStatusQueryOptions(voucherId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






